import React from 'react';
import {Row, Col} from 'reactstrap';


export default function Information(props) {

  return (
    <Row>
      <Col>
        <Row>
          <Col>
            <img className="img-fluid" 
            src={props.config.wedding.information} 
            alt={`${props.config.wedding.place.name}`} 
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
